import React from "react";
import ContentContainer from "../../templates/content-container/contentContainer";
import { PAGE_IDS } from "../../app/data/common/pageIds";

export const RpgAnalyzer: React.FC<{}> = () => {

  return (
    <ContentContainer
      pageId={PAGE_IDS.RPG_ANALYZER}
      title="RPG Analyzer"
    >
      <iframe
       style={{ width: "100%", height: "900px" }}
        src={process.env.REACT_APP_RPG_ANALYZER_URL || ""}
        title="RPG Analyzer"
        frameBorder="0"
        sandbox="allow-downloads allow-scripts allow-same-origin"
        referrerPolicy="strict-origin-when-cross-origin"
      >
      </iframe>
    </ContentContainer>
  );
};
